import { render, staticRenderFns } from "./anchorComponent.vue?vue&type=template&id=21f3f60a&scoped=true"
import script from "./anchorComponent.vue?vue&type=script&lang=js"
export * from "./anchorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f3f60a",
  null
  
)

export default component.exports